import CreateProductForm from "../../components/create/create-product-form";
import { BASE_URL } from '../../apiConfig';
import { useAuth } from "../../context/AuthProvider";
import { useEffect, useState } from 'react';
import Loading from "../../cors/Loading";
import axios from 'axios';

export default function CreateProductPage() {
  const { token } = useAuth();

  const [categories, setCategories] = useState([]);
  const [availableClients, setAvailableClients] = useState([]);
  const [availableVariants, setAvailableVariants] = useState([]);
  const [fournisseurs, setFournisseurs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!token) return;

    const axiosInstance = axios.create({
      baseURL: BASE_URL,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    const fetchData = async () => {
      try {
        const [categoriesRes, clientsRes, variantsRes, fournisseursRes] = await Promise.all([
          axiosInstance.get('/api/categories'),
          axiosInstance.get('/api/getsallers'),
          axiosInstance.get('/api/variants'),
          axiosInstance.get('/api/fournisseurs'),
        ]);

        setCategories(categoriesRes.data.data || []);
        setAvailableClients(clientsRes.data.data || []);
        setAvailableVariants(variantsRes.data || []);
        setFournisseurs(fournisseursRes.data || []);
      } catch (error) {
        console.error("Failed to fetch product form data:", error?.response?.data || error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [token]);

  if (loading) return <div className="flex justify-center py-72"><Loading /></div>;

  return (
    <div className="min-h-screen">
      <div className="container mx-auto px-4 py-12">
        <div className="text-center mb-12">
          <h1 className="text-4xl max-xl:text-3xl font-bold bg-gradient-to-r from-[var(--color-primary-500)] to-[var(--color-primary-400)] bg-clip-text text-transparent mb-4">
            Create New Product
          </h1>
          <p className="text-sm max-xl:text-sm text-gray-600 max-w-2xl mx-auto">
            Add a new product to your catalog with detailed information, variants, and client assignments.
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <CreateProductForm 
            categories={categories}
            availableClients={availableClients}
            availableVariants={availableVariants}
            Fournisseurs={fournisseurs}
          />
        </div>
      </div>
    </div>
  );
}
